#import "../../list/UserGroupFields.graphql"

mutation UserGroupUpdate($input: UserGroupUpdateInput!) {
  userGroupUpdate(input: $input) {
    userGroup {
      ...UserGroupFields
    }
  }
}
